
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'Logo',
    props: {
        alt: {
            type: String,
            required: true,
        },
    },
});
